module.exports = __webpack_public_path__ + "img/icon-question-upload.fa36b403.svg";